import ko from "knockout";
import _ from "lodash";
import $ from "jquery";

const EVENT_NAMESPACE = ".chatScrollBinding";
const DATA_KEY = "chatScrollBinding";

// ~ 2x nominal line height. If the user scrolls to within this many pixels of the bottom, auto scroll will activate
const AUTO_SCROLL_REGION = 70;

const isScrolledToBottom = function (element) {
    return (
        element.scrollTop >=
        element.scrollHeight - $(element).innerHeight() - AUTO_SCROLL_REGION
    );
};

const shouldScroll = function (element) {
    return ko.utils.domData.get(element, DATA_KEY);
};

/**
 * Scrolls to the bottom of the content, but only after the current
 * call stack completes. At that point any new elements should have
 * been inserted into the DOM.
 */
const applyScroll = function (element) {
    _.defer(function () {
        element.scrollTop = element.scrollHeight;
    });
};

const activateAutoScroll = function (element) {
    ko.utils.domData.set(element, DATA_KEY, true);
};

const deactivateAutoScroll = function (element) {
    ko.utils.domData.set(element, DATA_KEY, false);
};

/**
 * This causes the bound element to scroll whenever the data passed
 * to the binding updates. Ideally, this is the same data used to
 * insert messages or other elements into the dom which require scrolling
 *
 * The binding will not scroll the element if the user has scrolled away from
 * the bottom.
 *
 * Example:
 * <div data-bind="chatScroll: chatMessages()"></div>
 */
ko.bindingHandlers.chatScroll = {
    init: function (element) {
        $(element).on("scroll" + EVENT_NAMESPACE, function () {
            if (isScrolledToBottom(element)) {
                activateAutoScroll(element);
            } else {
                deactivateAutoScroll(element);
            }
        });
        activateAutoScroll(element);
        applyScroll(element);
    },

    update: function (element, valueAccessor) {
        ko.unwrap(valueAccessor()); //touch the value accessor, so we make sure the is called whenever the related observable changes
        if (shouldScroll(element)) {
            applyScroll(element);
        }
    },
};
